import { render, staticRenderFns } from "./OrgChartTemp5.vue?vue&type=template&id=74690a2a&scoped=true&"
import script from "./OrgChartTemp5.vue?vue&type=script&lang=js&"
export * from "./OrgChartTemp5.vue?vue&type=script&lang=js&"
import style0 from "./OrgChartTemp5.vue?vue&type=style&index=0&id=74690a2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74690a2a",
  null
  
)

export default component.exports